export default __webpack_public_path__ + "static/media/aceN Logo_old.fe21970c.png";